module.exports = __webpack_public_path__ + "static/media/alpha3.09bec1eb.png";